import React from "react";
import { BIO, IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Bio() {
  const r = useReveal();
  return (
    <section id="bio" className="bg-ls py-20 md:py-28">
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <div className="grid lg:grid-cols-[380px_1fr] gap-12 lg:gap-16 items-start">
          {/* Photo */}
          <div className="lg:sticky lg:top-24">
            <div className="hero-frame rounded-lg overflow-hidden">
              <img
                src={IMAGES.founder}
                alt={BIO.name}
                className="w-full h-[440px] md:h-[520px] object-cover object-top"
              />
            </div>
            <div className="mt-4">
              <div className="font-cond font-extrabold text-2xl text-white uppercase tracking-wide">
                {BIO.name}
              </div>
              <div className="text-orange text-sm font-semibold tracking-wide">{BIO.role}</div>
            </div>
          </div>

          {/* Text */}
          <div>
            <p className="ls-eyebrow mb-4">{BIO.eyebrow}</p>
            <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl mb-8">
              {BIO.heading}
            </h2>
            <div className="space-y-5">
              {BIO.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className={`leading-relaxed ${
                    i === BIO.paragraphs.length - 1
                      ? "text-white font-semibold text-lg border-l-2 pl-4"
                      : "text-[#c7bdae] text-[17px]"
                  }`}
                  style={
                    i === BIO.paragraphs.length - 1
                      ? { borderColor: "var(--ls-orange)" }
                      : undefined
                  }
                >
                  {p}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
